import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pyp-card',
  templateUrl: './pyp-card.component.html',
  styleUrls: ['./pyp-card.component.css']
})
export class PypCardComponent implements OnInit {

  @Input() pypCardData:any;

  constructor(private router:Router) { }

  ngOnInit(): void {
  }
  navigateToPYTest(){
    localStorage.removeItem('showAnseredQuestions');
    localStorage.setItem('pyqTargrtExamId',this.pypCardData.id)
    this.router.navigateByUrl('selfLearn-V2/pyp-chapter-questions');
  }
}
